/* eslint-disable eag/no-index */
/* eslint-disable eag/match-named-export */
export const DAMAGES_IN_VIEW_TRESHOLD = 0.5;
export const PAINT_IN_VIEW_TRESHOLD = 0.3;
export const WARNING_TRESHOLD = 300;
export const BASE_DELAY = 70;
export const POINT_DELAY = 25;
